import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '@tech-services/common.service';
import {
  ActivitiesService,
  OperativeBankInfoResponseInterface,
  OperativeModelPortfolioResponseInterface,
  OperativePortfolioResponseInterface,
  OperativeService,
} from '@techrules/portallib';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';

@Component({
  selector: 'tech-modal-partialdeposit',
  templateUrl: './modal-partialdeposit.component.html',
  styleUrls: ['./modal-partialdeposit.component.scss'],
})
export class ModalPartialdepositComponent implements OnInit {
  portfolioData: OperativePortfolioResponseInterface;

  currencySymbol: string;
  bankDataArr: any;
  bankData: OperativeBankInfoResponseInterface;
  modelPortfolioData: OperativeModelPortfolioResponseInterface;
  portfolioCode: string;
  activityId: string;
  activityType: string;
  isLoaded: boolean = false;
  msgMinuAmount = 0;
  msgInvalidAmount = '';
  msgVisible = false;
  myValue: string = '';
  private clientData: any;
  private unsubscribe$ = new Subject<void>();
  private allowOperations: any;
  public showButtons = true;
  isOpen = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private service: OperativeService,
    private activityservice: ActivitiesService,
    private common: CommonService,
    private dialogRef: MatDialogRef<ModalPartialdepositComponent>,
    private profileportfolioService: ProfileportfolioService
  ) {
    this.portfolioCode = dataDialog.portfolioCode;
    this.activityId = dataDialog.activityId;
    this.activityType = dataDialog.activityType;

    if (this.activityType === '15' || this.activityType === '23') {
      this.showButtons = false;
    }

    this.common.clientDataInitial$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.clientData = data;
      });

    this.profileportfolioService.portfolioData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        // console.log(data);
        this.allowOperations = data.AllowOperations;
      });
  }

  ngOnInit() {
    this.service.getPortfolioData(this.portfolioCode).subscribe((data) => {
      this.portfolioData = data;

      this.service
        .getBankInfo(
          data.serviceModelCode !== '' ? data.serviceModelCode : 'AP'
        )
        .subscribe((data) => {
          this.bankDataArr = data;
          const dd = this.bankDataArr.filter(
            (word: OperativeBankInfoResponseInterface) =>
              word.ccy === this.portfolioData.currency
          );

          if (dd.length > 0) {
            this.bankData = dd[0];
          } else {
            this.bankData = this.bankDataArr[0];
          }
          this.bankData.message = this.bankData.message
            .replace('{code}', this.portfolioData.portfolioCodeView)
            .replace('{name}', this.clientData.Name)
            .replace('{surname}', this.clientData.Surname);

          this.isLoaded = true;
        });
    });
  }

  deletepartial() {
    this.deletecontribution();
  }

  public deletecontribution() {
    this.activityservice
      .activitiesContribution(this.portfolioCode, this.activityId)
      .subscribe((data) => {
        console.log('canceladocontribution');
        this.allowOperations.AllowContribution = true;
        this.allowOperations.AllowWithdrawal = true;

        this.dialogRef.close();
      });
  }
}
